<template>
  <section class="chart-container">
    <el-row>
      <el-col :span="24">
        <el-table :data="apartmentSensorStatus" stripe style="width: 100%; margin-bottom: 10px; font-size: 1rem" @cell-click="sysStatusClick" ref="myTable">
          <el-table-column type="expand">
            <template slot-scope="props">
              <p>Hall Bridges: {{ props.row.hallBridges }}</p>
            </template>
          </el-table-column>
          <el-table-column v-for="column in columns" :key="column.label" :prop="column.prop" :label="column.label"> </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row v-if="showDatePicker">
      <el-col :span="24" style="padding-top: 0px; padding-bottom: 0px">
        <span class="demonstration">From</span>
        <el-date-picker v-model="fromDateCalendar" type="date" placeholder="From" format="MM-dd-yyyy" @change="fromDateChanged($event)"> </el-date-picker>
        <span class="demonstration" style="padding-left: 40px">To</span>
        <el-date-picker v-model="toDateCalendar" type="date" placeholder="To" format="MM-dd-yyyy" @change="toDateChanged($event)"> </el-date-picker>
        <el-button type="primary" v-on:click="csvExport">Export Data</el-button>
        <span style="margin-left: 30px" class="demonstration">Considered in Average</span>
        <el-checkbox v-model="avgConsidered"></el-checkbox>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div id="chartLine" style="width: 100%; height: 400px"></div>
      </el-col>
    </el-row>
  </section>
</template>

<script>
import echarts from "echarts"
import Axios from "axios"
import ApartmentsService from "@/api/apartments.service"
import ExportToCsv from "export-to-csv"

export default {
  data() {
    return {
      avgConsidered: false,
      showDatePicker: false,
      polling: null,
      apartmentSensorStatus: [],
      chartColumn: null,
      chartBar: null,
      chartLine: null,
      chartPie: null,
      user: this.$session.get("User"),
      fortest: 0,
      apartmentHistoryData: [],
      apartmentHistoryAxis: [],
      /*These below are used by the date picker*/
      toDateCalendar: new Date().toISOString(),
      fromDateCalendar: new Date().toISOString(),
      toDate: new Date(),
      fromDate: new Date(),
      floor: null,
      apartment: null,
      csvOptions: {
        fieldSeparator: ",",
        quoteStrings: '"',
        decimalSeparator: ".",
        showLabels: true,
        showTitle: true,
        title: "Varivac Data Export",
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
        // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
      },
      columns: [
        {
          prop: "floor",
          label: "Floor",
        },
      ],
    }
  },

  methods: {
    csvExport() {
      var arrData = this.apartmentHistoryData
      let csvContent = "data:text/csv;charset=utf-8,"
      csvContent += [Object.keys(arrData[0]).join(","), ...arrData.map((item) => Object.values(item).join(","))].join("\n").replace(/(^\[)|(\]$)/gm, "")

      const data = encodeURI(csvContent)
      const link = document.createElement("a")
      link.setAttribute("href", data)
      link.setAttribute("download", "export.csv")
      link.click()
    },
    fromDateChanged(event) {
      this.fromDate = new Date(event)
      this.getApartmentHistory(this.floor, this.apartment)
    },
    toDateChanged(event) {
      this.toDate = new Date(event)
      this.getApartmentHistory(this.floor, this.apartment)
    },
    drawLineChart(floor, apartment) {
      this.showDatePicker = true
      var apartmentName = floor + "-" + apartment
      this.chartLine = echarts.init(document.getElementById("chartLine"))
      this.chartLine.setOption({
        title: {
          text: "Apartment " + apartmentName,
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["Temperature °F  " + apartmentName],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "time",
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
          min: 60,
          max: 85,
          axisLabel: { formatter: "{value} °F" },
        },
        series: [
          {
            name: "Temperature °F  " + apartmentName,
            type: "line",
            stack: "总量",
            showSymbol: false,
            data: this.apartmentHistoryData,
          },
        ],
      })
    },
    getApartmentHistory(floor, apartment) {
      var toDate = this.toDate
      toDate.setUTCHours(23)
      toDate.setUTCMinutes(59)
      var toDateFormatted = toDate.toISOString()
      var fromDateFormatted = this.fromDate.toISOString()
      Axios.all([ApartmentsService.getApartmentHistory(this.user.activeZone, floor, apartment, fromDateFormatted, toDateFormatted)]).then(
        Axios.spread((ApartmentsResponse) => {
          this.apartmentHistoryData = []
          this.apartmentHistoryAxis = []
          for (let item of ApartmentsResponse.data) {
            this.apartmentHistoryData.push([item.time, item.temperature])
            //this.apartmentHistoryAxis.push(item.time);
          }
          this.drawLineChart(floor, apartment)
        })
      )
    },
    getApartmentData(floor, apartment) {
      Axios.all([ApartmentsService.getApartmentData(this.user.activeZone, floor, apartment)]).then(
        Axios.spread((ApartmentsResponse) => {
          console.log(ApartmentsResponse.data)
          this.avgConsidered = ApartmentsResponse.data.isConsideredInAvg == 1
        })
      )
    },
    sysStatusClick(row, column, cell, event) {
      console.log(row.floor)
      console.log(column.property)
      if (column.property != "Floor") {
        /*We save these here just in case the user changes the dates*/
        this.floor = row.floor
        this.apartment = column.property
        this.getApartmentHistory(this.floor, this.apartment)
        this.getApartmentData(this.floor, this.apartment)
      }
    },
    toFahrenheit(degC) {
      console.log(degC)
      if (typeof degC === "undefined") {
        return ""
      } else {
        return (degC * (9 / 5) + 32).toFixed(1) + "°F"
      }
    },
    compare(a, b) {
      return a.floor < b.floor ? 1 : -1
    },
    isInArray(floor) {
      for (var i = 0; i < this.apartmentSensorStatus.length; i++) {
        if (this.apartmentSensorStatus[i].floor == floor) {
          return i
        }
      }
      return -1
    },
    createColumns() {
      Axios.all([ApartmentsService.getApartmentLettersInZone(this.user.activeZone)]).then(
        Axios.spread((ApartmentLettersResponse) => {
          //Apartment Letters
          if (typeof ApartmentLettersResponse.data.error !== "undefined") {
          } else {
            ApartmentLettersResponse.data.forEach((element) => {
              this.columns.push({
                prop: element.apartment,
                label: element.apartment,
              })
            })
          }
        })
      )
    },
    getData() {
      Axios.all([ApartmentsService.getApartmentSensors(this.user.activeZone)]).then(
        Axios.spread((ApartmentsResponse) => {
          //Apartment Sensors
          if (typeof ApartmentsResponse.data.error !== "undefined") {
            //No apartment sensors
          } else {
            //Clear the hallway bridges
            this.apartmentSensorStatus.forEach((element) => {
              element.hallBridges = ""
            })

            for (let sensor of ApartmentsResponse.data) {
              var checkIfInArray = this.isInArray(sensor.floor)
              if (checkIfInArray == -1) {
                var newFloor = {
                  floor: sensor.floor,
                  hallBridges: "",
                }
                if (sensor.isHallBridge == 1) {
                  newFloor.hallBridges += sensor.sensor_id + " " + sensor.floor + sensor.apartment + ":" + (sensor.online ? "Online" : "Offline") + "<br>"
                } else {
                  if (!sensor.online) {
                    newFloor[sensor.apartment] = "Offline"
                  } else {
                    newFloor[sensor.apartment] = this.toFahrenheit(sensor.currentTemperature)
                  }
                }
                this.apartmentSensorStatus.push(newFloor)
              } else {
                if (sensor.isHallBridge == 1) {
                  this.apartmentSensorStatus[checkIfInArray].hallBridges += "[" + sensor.sensor_id + " " + sensor.floor + sensor.apartment + ":" + (sensor.online ? "Online" : "Offline") + "] "
                } else {
                  if (!sensor.online) {
                    this.apartmentSensorStatus[checkIfInArray][sensor.apartment] = "Offline"
                  } else {
                    this.apartmentSensorStatus[checkIfInArray][sensor.apartment] = this.toFahrenheit(sensor.currentTemperature)
                  }
                }
              }
            }
            this.apartmentSensorStatus.sort(this.compare)
            this.$refs.myTable.doLayout()
            console.log(this.apartmentSensorStatus)
          }
        })
      )
    },
  },

  mounted: function () {
    var yesterday = new Date()
    yesterday.setDate(new Date().getDate() - 8)
    this.fromDate = yesterday
    this.fromDateCalendar = yesterday.toISOString()

    this.getData()
    this.createColumns()
    this.polling = setInterval(this.getData, 10000)
    //this.drawLineChart(17, "A");
  },
  beforeDestroy() {
    clearInterval(this.polling)
  },
  updated: function () {
    //this.drawCharts();
  },
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  float: left;
}
/*.chart div {
        height: 400px;
        float: left;
    }*/

.el-col {
  padding: 30px 20px;
}
</style>



// WEBPACK FOOTER //
// ApartmentSensors.vue?a870e354